var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainPage"},[_c('v-container',{attrs:{"fluid":""}},[_c('ArticleSummary',{attrs:{"articles":_vm.articles}}),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","lg":"4"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }